import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CustomerView, StateList, StatesList } from './customers.model';
import { RootState } from 'store/reducers';

interface CustomerSliceState {
  statesList?: StatesList;
  currentCustomerView: CustomerView | null;
  customerViewFilters: Record<string, any>;
}

const initialState: CustomerSliceState = {
  statesList: [],
  currentCustomerView: null,
  customerViewFilters: {}
};

const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    updateStatesList: (state, { payload }: PayloadAction<StateList[]>) => {
      state.statesList = payload;
    },
    setCurrentCustomerView: (state, { payload }: PayloadAction<CustomerView | null>) => {
      state.currentCustomerView = payload;
    },
    setCustomerViewFilters: (state, { payload }: PayloadAction<Record<string, any>>) => {
      state.customerViewFilters = payload;
    },
    clearCustomerViewFilters: state => {
      state.customerViewFilters = {};
    }
  }
});

export const selectStates = (state: RootState) => state.rootReducer.customers.statesList;
export const selectCurrentCustomerView = (state: RootState) => state.rootReducer.customers.currentCustomerView;
export const selectCustomerViewFilters = (state: RootState) => state.rootReducer.customers.customerViewFilters;

export const { updateStatesList, setCurrentCustomerView, setCustomerViewFilters, clearCustomerViewFilters } =
  customersSlice.actions;

export default customersSlice.reducer;
